import React from 'react';

export const LineIcon = ({ stroke = '#020617' }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33301 8H12.6663" stroke={stroke} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}